// extracted by mini-css-extract-plugin
export default {"right_outer_container":"index_right_outer_container__ZkFGY","right_image":"index_right_image__Iwj-R","secondary_button":"index_secondary_button__imUx6"};